/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Input } from '../forms';

const DeleteMePassword = (props) => {
  const { value, error, onChange } = props;

  return (
    <div className={`form-group required mbm${error ? ' error' : ''}`}>
      <label htmlFor="MembersCurrentPassword">{get(translations, 'txt: Jūsu parole', '')}</label>
      <Input
        type="password"
        name="current_password"
        value={value}
        className="form-control"
        id="MembersCurrentPassword"
        doneTyping={onChange}
      />
      {error && (
        <div className="error">
          <div className="inner">
            {error}
          </div>
        </div>
      )}
    </div>
  );
};

DeleteMePassword.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

DeleteMePassword.defaultProps = {
  value: '',
  error: '',
};

export default DeleteMePassword;
